import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { useAuth } from '@domain/auth/auth.hook';
import { AxiosResponse, CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { PlayerDataProps } from '@screens/players/types/player.data.props';

const columns = [
  { field: 'bounces', headerName: 'Bounces', width: 140 },
  { field: 'ootos', headerName: 'Ootos', width: 120 },
  { field: 'complaint', headerName: 'Complaint', width: 150 },
  { field: 'blacklist', headerName: 'Blacklist', width: 140 },
  { field: 'delivers', headerName: 'Delivers', width: 130 },
  { field: 'opens', headerName: 'Opens', width: 120 },
  { field: 'clicks', headerName: 'Clicks', width: 120 },
  { field: 'problems', headerName: 'Problems', width: 140 },
  { field: 'unsub', headerName: 'Unsub', width: 122 },
  { field: 'deliversRolling', headerName: 'Delivers Rolling', width: 180 },
  { field: 'ootosRolling', headerName: 'Ootos Rolling', width: 170 },
  { field: 'bouncesRolling', headerName: 'Bounces Rolling', width: 180 },
  { field: 'lastClickOpen', headerName: 'Last Click Open', width: 190 },
  { field: 'lastDeliver', headerName: 'Last Deliver', width: 160 },
  { field: 'lastOoto', headerName: 'Last Ooto', width: 140 },
  { field: 'lastBounce', headerName: 'Last Bounce', width: 170 },
  { field: 'lastComplaint', headerName: 'Last Complaint', width: 180 },
  { field: 'lastUnsub', headerName: 'Last Unsub', width: 160 },
  { field: 'timestamp', headerName: 'Timestamp', width: 160 },
];

interface EmailInfo {
  pid: number;
  bounces: number;
  ootos: number;
  complaint: boolean;
  blacklist: boolean;
  delivers: number;
  opens: number;
  clicks: number;
  problems: number;
  unsub: boolean;
  deliversRolling: number;
  ootosRolling: number;
  bouncesRolling: number;
  lastClickOpen: string;
  lastDeliver: string;
  lastOoto: string;
  lastBounce: string;
  lastComplaint: string;
  lastUnsub: string;
  timestamp: string;
}

let index = 0;
function createData(info: EmailInfo) {
  index += 1;
  return { id: index, ...info };
}

const EmailDeliverability = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<EmailInfo[]>(`/admin/email-deliverability/${requestPid}/list`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<EmailInfo[]>;
        throw error;
      });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });
  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  return (
    <>
      <TabTableContainer>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default EmailDeliverability;
